import React, { PropsWithChildren } from "react";
//#region types
import { BannerProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import ViewPanel from "../panels/viewPanel";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Banner: React.FC<PropsWithChildren<BannerProps>> = (props) => {
  return (
    <ViewPanel
      {...props}
      className={clsx(props.className, cssExports.banner, CSSHelper.getClassByDisplayType(props.type))}
    >
      {props.children}
    </ViewPanel>
  );
};

export default Banner;
